import React from 'react';
import Button from '../Button';
import StateHeading from './StateHeading';
import UpgradeProgressStep from './UpgradeProgressStep';
import { SuccessData } from './types';

interface Props extends SuccessData {
  title: string;
  onSeeTransactions: () => void;
  actionPending?: boolean;
}

export default function Success({
  title,
  transactionCount,
  taxYearCount,
  onSeeTransactions,
  actionPending,
}: Props) {
  const labels = [
    `${transactionCount.toLocaleString('en-US')} ${
      transactionCount === 1 ? 'transaction' : 'transactions'
    } migrated`,
    `Cost basis recalculated across ${taxYearCount.toLocaleString('en-US')} tax ${
      taxYearCount === 1 ? 'year' : 'years'
    }`,
    'Upgrade finalized',
  ];
  return (
    <>
      <StateHeading title={title}>
        Everything is ready in the new data model. Your original account snapshot remains safely stored.
      </StateHeading>
      <ol className="space-y-4" aria-label="Completed upgrade">
        {labels.map((label, index) => (
          <UpgradeProgressStep key={label} label={label} status="completed" number={index + 1} />
        ))}
      </ol>
      <Button
        type="button"
        variant="primary"
        fullWidth
        loading={actionPending}
        disabled={actionPending}
        onClick={onSeeTransactions}
      >
        See your transactions
      </Button>
    </>
  );
}
